import React, { useEffect, useState } from 'react';
import { INTERFACE_TEXT } from '../../constants/interfaceText';
import LanguageChoices from './LanguageChoices';
import TodayHeader from './TodayHeader';
import styles from './LanguageSwitcher.module.css';
import todayStyles from './TodayScreen.module.css';

const PICK_HEADING_ID = 'pick-language-heading';

interface PickLanguageProps {
  /** Locales with tracks, offered because the learner has no current language yet. */
  available: string[];
  /** Make the locale current; rejects when the switch fails. */
  onChoose: (locale: string) => Promise<void>;
}

/** Full-screen choice for a learner with several languages on offer and none chosen (BR-050). */
export const PickLanguage: React.FC<PickLanguageProps> = ({
  available,
  onChoose,
}) => {
  const [pending, setPending] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => document.getElementById(PICK_HEADING_ID)?.focus(), []);

  const choose = async (locale: string): Promise<void> => {
    if (pending) return;
    setPending(true);
    setFailed(false);
    try {
      await onChoose(locale);
    } catch {
      setFailed(true);
      setPending(false);
    }
  };

  return (
    <div className={todayStyles.root}>
      <TodayHeader />
      <main className={styles.pick}>
        <h1 id={PICK_HEADING_ID} tabIndex={-1} className={styles.pickHeading}>
          {INTERFACE_TEXT.tdLangPickHeading}
        </h1>
        <p className={styles.pickIntro}>{INTERFACE_TEXT.tdLangPickIntro}</p>
        <div className={styles.pickList}>
          <LanguageChoices
            locales={available}
            disabled={pending}
            onChoose={(locale) => void choose(locale)}
          />
        </div>
        {failed && (
          <p role="alert" className={styles.error}>
            {INTERFACE_TEXT.tdLangSwitchFailed}
          </p>
        )}
      </main>
    </div>
  );
};

export default PickLanguage;
